module.exports = __webpack_public_path__ + "static/img/SupandSerc.80c103e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SupandSerc.png
// module id = cr7c
// module chunks = 1